import { useState } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styles from "./AddMembers.module.css";

const AddMembers = ({ isModal = false, onCancel, onSave }) => { // onSave prop will be used to save data to db
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [members, setMembers] = useState([]); // State to store members that have been entered during the session
  const [errors, setErrors] = useState({ name: "", email: ""}); // State to store validation errors
  const navigate = useNavigate();

  const handleSuccess = () => {
    // alert("Members successfully saved!"); // Notify the user
  
    if (isModal) {
      onCancel(); // Close the modal if it's being used as a modal
    }
  };
  

  const handleAddEmailField = () => {
    let hasError = false;
    const newErrors = { name: "", email: "" };
    
    if (!name.trim()) {
      newErrors.name = "***Name is required";
      hasError = true;
    }
  
    if (!email.trim()) {
      newErrors.email = "***Email is required";
      hasError = true;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "***Invalid email format";  // Display error only when button is clicked
      hasError = true;
    }
  
    setErrors(newErrors);  // Update errors state
    if (hasError) return;  // Stop further execution if there are errors
  
    // Add member to the list if validation passes
    setMembers([...members, { name, email }]);
    setEmail("");  // Reset the email field
    setName("");  // Reset the name field
    setErrors({ name: "", email: "" });  // Clear any errors
  };
  
  // Capture members added and save them to the parent component
  const handleFormSubmit = async () => {
    if (name.trim() || email.trim()) {
      // Validate inputs
      let hasError = false;
      const newErrors = { name: "", email: "" };
  
      if (!name.trim()) {
        newErrors.name = "***Name is required";
        hasError = true;
      }
  
      if (!email.trim()) {
        newErrors.email = "***Email is required";
        hasError = true;
      } else if (!/\S+@\S+\.\S+/.test(email)) {
        newErrors.email = "***Invalid email format";
        hasError = true;
      }
  
      setErrors(newErrors);
      if (hasError) return;
  
      // Add the last input to the members list
      const updatedMembers = [...members, { name, email }];
      setMembers(updatedMembers);

      // Trigger the save logic
      if (onSave) {
        try {
          await onSave(updatedMembers); // Pass all members to the parent
          handleSuccess();
        } catch (error) {
          console.error("Failed to save members:", error);
          alert("Failed to save members.");
        }
      }
    } else if (members.length === 0) {
      alert("Please add at least one member before submitting.");
    } else {
      // If no new name/email but members already exist
      if (onSave) {
        try {
          await onSave(members);
          handleSuccess();
        } catch (error) {
          console.error("Failed to save members:", error);
          alert("Failed to save members.");
        }
      }
    }
  };
  
  const handleEmailChange = (event) => {
    setEmail(event.target.value);  // Only update email state without triggering validation
  };
  
  const handleNameChange = (event) => {
    setName(event.target.value);
    if (event.target.value.trim()) {
      setErrors((prevErrors) => ({ ...prevErrors, name: "" }));
    }
  };

  const handleCancelClick = () => {
    if (isModal) {
      onCancel(); // Close the modal
    } else {
      navigate("/commissionerdash"); // Navigate to another page
    }
  };

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Invite league members</h3>
      <div className={styles.divider} />
      <div className={styles.emailInputArea}>
        <div className={styles.emailLabel}>Name
        </div>
        <div className={styles.nameInputWrapper}>
          <input
            className={`${styles.nameInput} ${errors.name ? styles.inputError : ""}`}
            placeholder={errors.name || "Enter name"} // On click if required value is missing show error else show placeholder text
            type="text"
            value={name}
            onChange={handleNameChange}
          />
        </div>
        
        <div className={styles.emailLabel}>
          Email
          {errors.email && (
            <div className={styles.errorMessage}>{errors.email}</div>  // Conditionally render the error message
            )}
        </div>
        <div className={styles.emailInputWrapper}>
          <input
            className={`${styles.emailInput} ${errors.email ? styles.inputError : ""}`}
            placeholder={errors.email || "Enter email address"} 
            type="text"
            value={email}
            onChange={handleEmailChange}
          />
        </div>
        
      </div>
      <div className={styles.addEmailButton} onClick={handleAddEmailField}>
        + Add another
      </div>
      {/* Show members added and waiting to be saved */}
      {members.length > 0 && (
        <div className={styles.memberList}>
          <h4 className={styles.memberListTitle}>Members to add</h4>
          {members.map((member, index) => (
            <div className={styles.memberItem} key={index}>
              <span className={styles.memberName}>{member.name}</span> - <span className={styles.memberEmail}>{member.email}</span>
            </div>
          ))}
        </div>
      )}
      <div className={styles.buttonContainer}>
        <Button
          className={styles.buttonPrimary}
          disableElevation
          variant="contained"
          onClick={handleFormSubmit} // Handle form submission here
        >
          Finish
        </Button>
        <div className={styles.skip} onClick={handleCancelClick}>
          Cancel
        </div>
      </div>
    </div>
  );
};

export default AddMembers;

